import './CarModelIntelligentSystemBlock.scss';
import React from 'react';
import ScrollFixedImages from './ScrollFixedImages/ScrollFixedImages';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function IntelligentSystemBlock({ fields }) {
  return (
    <div className={'container car-model-system-block'}>
      <div className={'wrapper'}>
        <h2 className={'title'} data-aos="fade-up">
          <RichText field={fields?.text} />
        </h2>
        <ScrollFixedImages scrollingSlidesJaecooJ7Phev={fields?.styles} />
      </div>
    </div>
  );
}
